export const scrolltoView = (blockRef: any) =>
  blockRef?.current &&
  blockRef?.current?.scrollIntoView({
    behavior: "smooth",
    block: "end",
  });
